/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegistrierungVO { 
    id?: number;
    emailAdresse: string;
    anrede: RegistrierungVO.AnredeEnum;
    vorname: string;
    nachname: string;
    vorgestellterTitel?: string;
    nachgestellterTitel?: string;
    geburtsdatum: string;
    adresse: string;
    adresszusatz?: string;
    postleitzahl: string;
    ort: string;
    bundesland?: RegistrierungVO.BundeslandEnum;
    telefon?: string;
    mobilTelefon?: string;
    beruf: RegistrierungVO.BerufEnum;
    oeaekNummer?: string;
    fachrichtungen?: Set<RegistrierungVO.FachrichtungenEnum>;
    gutachterTaetigkeiten: Set<RegistrierungVO.GutachterTaetigkeitenEnum>;
    passwort: string;
}
export namespace RegistrierungVO {
    export type AnredeEnum = 'HERR' | 'FRAU';
    export const AnredeEnum = {
        HERR: 'HERR' as AnredeEnum,
        FRAU: 'FRAU' as AnredeEnum
    };
    export type BundeslandEnum = 'BURGENLAND' | 'KAERNTEN' | 'NIEDEROESTERREICH' | 'OBEROESTERREICH' | 'SALZBURG' | 'STEIERMARK' | 'TIROL' | 'VORARLBERG' | 'WIEN';
    export const BundeslandEnum = {
        BURGENLAND: 'BURGENLAND' as BundeslandEnum,
        KAERNTEN: 'KAERNTEN' as BundeslandEnum,
        NIEDEROESTERREICH: 'NIEDEROESTERREICH' as BundeslandEnum,
        OBEROESTERREICH: 'OBEROESTERREICH' as BundeslandEnum,
        SALZBURG: 'SALZBURG' as BundeslandEnum,
        STEIERMARK: 'STEIERMARK' as BundeslandEnum,
        TIROL: 'TIROL' as BundeslandEnum,
        VORARLBERG: 'VORARLBERG' as BundeslandEnum,
        WIEN: 'WIEN' as BundeslandEnum
    };
    export type BerufEnum = 'ARZT' | 'PFLEGER' | 'PSYCHOLOGE';
    export const BerufEnum = {
        ARZT: 'ARZT' as BerufEnum,
        PFLEGER: 'PFLEGER' as BerufEnum,
        PSYCHOLOGE: 'PSYCHOLOGE' as BerufEnum
    };
    export type FachrichtungenEnum = 'KEINE' | 'ALLGEMEIN_MEDIZIN' | 'INNERE_MEDIZIN' | 'NEUROLOGIE' | 'ORTHOPAEDIE' | 'PSYCHIATRIE' | 'SONSTIGE_FACHRICHTUNG';
    export const FachrichtungenEnum = {
        KEINE: 'KEINE' as FachrichtungenEnum,
        ALLGEMEINMEDIZIN: 'ALLGEMEIN_MEDIZIN' as FachrichtungenEnum,
        INNEREMEDIZIN: 'INNERE_MEDIZIN' as FachrichtungenEnum,
        NEUROLOGIE: 'NEUROLOGIE' as FachrichtungenEnum,
        ORTHOPAEDIE: 'ORTHOPAEDIE' as FachrichtungenEnum,
        PSYCHIATRIE: 'PSYCHIATRIE' as FachrichtungenEnum,
        SONSTIGEFACHRICHTUNG: 'SONSTIGE_FACHRICHTUNG' as FachrichtungenEnum
    };
    export type GutachterTaetigkeitenEnum = 'KEINE' | 'AUVA' | 'BVAEB' | 'PVA' | 'SVS';
    export const GutachterTaetigkeitenEnum = {
        KEINE: 'KEINE' as GutachterTaetigkeitenEnum,
        AUVA: 'AUVA' as GutachterTaetigkeitenEnum,
        BVAEB: 'BVAEB' as GutachterTaetigkeitenEnum,
        PVA: 'PVA' as GutachterTaetigkeitenEnum,
        SVS: 'SVS' as GutachterTaetigkeitenEnum
    };
}


